import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    theme: {},
    isLoading: false,
    error: ''
};

const toKebabCase = (str: string) =>
  str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();

export const updateThemeVariables = (
  theme: Record<string, string>,
  mode: 'apply' | 'clear'
) => {
  Object.entries(theme).forEach(([key, value]) => {
    const cssVarName = `--${toKebabCase(key)}`;
    if (mode === 'apply' && typeof value === 'string') {
      document.documentElement.style.setProperty(cssVarName, value);
    } else if (mode === 'clear') {
      document.documentElement.style.removeProperty(cssVarName);
    }
  });
};

const themeSlice = createSlice({
    name: 'theme',
    initialState,
    reducers: {
        getThemePending: (state) => {
            state.isLoading = true;
        },
        getThemeSuccess: (state, { payload }) => {
            state.isLoading = false;
            state.theme = payload;
            state.error = '';
            updateThemeVariables(payload, 'apply');
        },
        getThemeFail: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            updateThemeVariables(state.theme, 'clear');
            state.theme = {};
        },
    },
});

const { reducer, actions } = themeSlice;

export const { getThemeSuccess, getThemePending, getThemeFail } = actions;

export default reducer;
